import { createRouter, createWebHistory } from 'vue-router'
import { installNavigationEffects } from './navigation'
import { routes } from './routes'

// The app scrolls inside the shell's content sheet, not the window, so `installNavigationEffects` owns scroll.
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

installNavigationEffects(router)

// `meta.title` holds an i18n key, not display text; App.vue keeps `document.title` translated.

export default router
